import { atom } from 'jotai';
import { SidePanelTab } from 'src/components/Events/EventPage/SidePanel/SidePanelHeader';
import { refreshShouldRepaintVenueMapAtom } from 'src/components/Events/VenueMap/VenueMap.atoms';

export const activeTabAtom = atom<SidePanelTab>(SidePanelTab.LISTINGS);

export const setActiveTabAtom = atom(
  null,
  (_, set, newActiveTab: SidePanelTab) => {
    set(activeTabAtom, newActiveTab);
    set(refreshShouldRepaintVenueMapAtom, true);
  }
);
